class HTUSection {
  constructor(sectionEl, data) {
    this.sectionEl = sectionEl;
    this.data = data;
    this.gridEl = sectionEl.querySelector('.htu-section__grid');
    this.proTipEl = sectionEl.querySelector('.htu-pro-tip');
    this.proTipLabelEl = this.proTipEl && this.proTipEl.querySelector('.htu-pro-tip__label');
    this.proTipDescEl = this.proTipEl && this.proTipEl.querySelector('.htu-pro-tip__desc');
    this._bindEvents();
  }

  static escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  _buildCardsHTML(cards) {
    return cards.map(card => {
      var html = '<div class="htu-card">';
      if (card.title) {
        html += '<h3 class="htu-card__title">' + HTUSection.escapeHtml(card.title) + '</h3>';
      }
      if (card.image) {
        html +=
          '<div class="htu-card__image-wrap">' +
          '<img class="htu-card__image" src="' +
          HTUSection.escapeHtml(card.image) +
          '" alt="' +
          HTUSection.escapeHtml(card.title || '') +
          '" loading="lazy" width="200" height="200">' +
          '</div>';
      }
      if (card.list) {
        var items = card.list
          .split('|')
          .map(s => s.trim())
          .filter(Boolean);
        if (items.length) {
          html += '<ul class="htu-card__list">';
          items.forEach(item => {
            html += '<li class="htu-card__list-item">' + HTUSection.escapeHtml(item) + '</li>';
          });
          html += '</ul>';
        }
      }
      html += '</div>';
      return html;
    }).join('');
  }

  _updateBackground(vData) {
    var bg = vData && vData.bg ? vData.bg : null;
    var defaultBg = this.sectionEl.getAttribute('data-default-bg');
    var defaultBgEven = this.sectionEl.getAttribute('data-default-bg-even');

    if (bg) {
      var bgStr = Array.isArray(bg) ? bg.join(' ') : String(bg);
      var bgParts = bgStr.replace(/#/g, '').split(/\s+/).filter(s => s.trim() !== '');
      if (bgParts[0]) this.sectionEl.style.setProperty('--htu-card-bg', '#' + bgParts[0]);
      if (bgParts[1]) {
        this.sectionEl.style.setProperty('--htu-card-bg-even', '#' + bgParts[1]);
      } else if (bgParts[0]) {
        this.sectionEl.style.setProperty('--htu-card-bg-even', '#' + bgParts[0]);
      }
    } else {
      if (defaultBg) this.sectionEl.style.setProperty('--htu-card-bg', defaultBg);
      if (defaultBgEven) this.sectionEl.style.setProperty('--htu-card-bg-even', defaultBgEven);
    }
  }

  _updateProTip(proTipRaw) {
    if (!this.proTipEl || !this.proTipLabelEl || !this.proTipDescEl) return;
    if (proTipRaw) {
      var ptParts = proTipRaw.split('#');
      this.proTipLabelEl.textContent = (ptParts[1] || '').trim();
      this.proTipDescEl.textContent = (ptParts[2] || '').trim();
      this.proTipEl.classList.remove('htu-pro-tip--hidden');
    } else {
      this.proTipEl.classList.add('htu-pro-tip--hidden');
    }
  }

  update(variantId) {
    var vData = this.data.variants && this.data.variants[String(variantId)];
    var cards = vData && vData.cards && vData.cards.length ? vData.cards : null;

    this._updateBackground(vData);
    this._updateProTip(vData && vData.proTip ? vData.proTip : null);

    if (!this.gridEl) return;

    if (cards) {
      this.gridEl.innerHTML = this._buildCardsHTML(cards);
      this.sectionEl.classList.remove('htu-no-data');
    } else {
      this.gridEl.innerHTML = '';
      this.sectionEl.classList.add('htu-no-data');
    }
  }

  _bindEvents() {
    document.addEventListener('variant-change', e => {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        this.update(String(e.detail.variant.id));
      }
    });

    document.body.addEventListener('change', e => {
      var t = e.target;
      if (
        t &&
        t.name === 'id' &&
        t.form &&
        String(t.form.id || '').indexOf('product-form-') === 0
      ) {
        this.update(t.value);
      }
    });
  }

  static init() {
    document.querySelectorAll('[data-htu-section]').forEach(sectionEl => {
      var sectionId = sectionEl.getAttribute('data-section-id');
      if (!sectionId) return;

      var scriptEl = document.getElementById('htu-data-' + sectionId);
      if (!scriptEl) return;

      var data;
      try {
        data = JSON.parse(scriptEl.textContent);
      } catch (e) {
        return;
      }

      new HTUSection(sectionEl, data);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', HTUSection.init);
} else {
  HTUSection.init();
}
